import * as React from "react";

export const CsvIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6 0C0.7175 0 0 0.7175 0 1.6V11.2C0 12.0825 0.7175 12.8 1.6 12.8H8C8.8825 12.8 9.6 12.0825 9.6 11.2V4.2625C9.6 3.8375 9.4325 3.43 9.1325 3.13L6.4675 0.4675C6.1675 0.1675 5.7625 0 5.3375 0H1.6ZM8.1375 4.4H5.8C5.4675 4.4 5.2 4.1325 5.2 3.8V1.4625L8.1375 4.4Z"
      fill="#99A0A7"
    />
  </svg>
);
